import React from 'react';

const MinisiteTagListConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/tags',
      exact: true,
      component: React.lazy(() => import('./minisite_tag_list'))
    }
  ]
};

const MinisiteTagAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/tags/create',
      exact: true,
      component: React.lazy(() => import('./minisite_tag_create'))
    }
  ]
};

const MinisiteTagEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/minisite/tags/edit/:id',
      exact: true,
      component: React.lazy(() => import('./minisite_tag_edit'))
    }
  ]
};

export { MinisiteTagListConfig, MinisiteTagAddConfig, MinisiteTagEditConfig };
